import { TagEventsEnum } from 'common/enums/TagEventsEnum'
import BaseBridge from 'config/bridge/BaseBridge'

export const AnalyticsLandingPage = (params?: Record<string, string>) => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    screen: 'home sortezinha',
    product: 'sortezinha',
    flow: 'prateleira',
    ...params,
  })
}

export const analyticsLandingPageLoad = (params?: Record<string, string>) => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    screen_name: 'Sortezinha:Home',
    product_area: 'Home',
    product: 'capitalização',
    step: '1',
    ...params,
  })
}

export const analyticsRedeemNowTag = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    ref_figma: '96',
    screen: 'home sortezinha',
    ref_type: 'botão',
    action_id: 'resgatar agora',
    content_action: 'toque',
    product: 'capitalização',
    flow: 'resgate',
  })
}
